import * as React from 'react';
import { css } from 'aphrodite';
import { styles } from './WidgetListItem.styles';

export const WidgetListItem: React.FC = ({ children }) => {
	return <div className={css(styles.item)}>{children}</div>;
};
